import React from 'react';
import styled from 'styled-components';
import FilterButton from '../FilterButton';
import type { FilterButtonProps } from '../FilterButton/FilterButton';
import { TEST_ID_FILTER_BUTTON_LIST } from './constants';

export interface FilterButtonListProps {
  filters: Omit<FilterButtonProps, 'onClick'>[];
  onClickButton: ({
    name,
    isSelected,
  }: {
    name: string;
    isSelected: boolean;
  }) => void;
}

export const FilterButtonList = ({
  filters,
  onClickButton,
}: FilterButtonListProps) => (
  <StyledFilterButtonList data-testid={TEST_ID_FILTER_BUTTON_LIST}>
    {filters.map((filter) => {
      const { name, title, isSelected, count } = filter;
      return (
        <FilterButton
          key={name}
          title={title}
          count={count}
          name={name}
          onClick={onClickButton}
          isSelected={isSelected}
        />
      );
    })}
  </StyledFilterButtonList>
);

const StyledFilterButtonList = styled.div`
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
  margin-bottom: 8px;
`;
